import type { FeatureKey, Features } from 'models/features';
import type { FrontRights } from 'models/libs/FrontRights';

import type { UserState } from '../user.model';
import { isUserInternal } from '../user.selector';

export function getUserFeatures(state: UserState): Features {
  return state.features;
}

export function getFrontRights(state: UserState): FrontRights {
  return state.entitlements;
}

export function isFeatureEnabled(state: UserState, feature: FeatureKey): boolean {
  return !!(state && state.features && state.features[feature] === 'on');
}

export function isSecondaryMarketEnabled(state: UserState): boolean {
  return !!(state && state.entitlements && state.entitlements.secondaryTradeEnabled);
}

export function isTradeEnabled(state: UserState): boolean {
  return !!(state && state.entitlements && state.entitlements.tradeEnabled);
}

export function isFeedbackEnabled(state: UserState): boolean {
  return !!(state && state.entitlements && state.entitlements.feedbackEnabled);
}

export function isOrdersBasketEnabled(state: UserState): boolean {
  return isUserInternal(state);
}

export function isSecondaryMarketBlotterEnabled(state: UserState): boolean {
  return isSecondaryMarketEnabled(state);
}
